import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Tag } from "./Tag";
export function FlowListRow({
  name,
  place,
  openLabel,
  behindLabel,
  isMuted = false,
  className
}: {
  name: string;
  place?: string | null;
  openLabel: string;
  behindLabel?: string;
  isMuted?: boolean;
  className?: string;
}) {
  return <div className={cn("flex min-h-[40px] min-w-0 items-center gap-2.5 whitespace-nowrap py-2", className)} data-sentry-component="FlowListRow" data-sentry-source-file="FlowListRow.tsx">
            <span className="flex min-w-0 flex-1 items-baseline gap-2">
                <span title={name} className={cn("min-w-0 truncate text-body", isMuted ? "text-ink-2" : "text-ink")}>
                    {name}
                </span>
                {place && <span className="min-w-0 truncate text-footnote text-ink-3">
                        {place}
                    </span>}
            </span>
            <span className="flex-shrink-0 font-mono text-callout tabular-nums text-ink-2">
                {openLabel}
            </span>
            {behindLabel && <Tag tone="peach" className="flex-shrink-0">
                    {behindLabel}
                </Tag>}
        </div>;
}
export function FlowList({
  children,
  className
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn("flex min-w-0 flex-col divide-y divide-ink/[0.08]", className)} data-sentry-component="FlowList" data-sentry-source-file="FlowListRow.tsx">
            {children}
        </div>;
}